export default __webpack_public_path__ + "static/media/after.d2323def.png";